<template>
	<div class="app">
		<LayoutHeader />

		<router-view></router-view>

		<LayoutFooter />
	</div>
</template>

<script>
import LayoutHeader from '@/components/Layout/header'
import LayoutFooter from '@/components/Layout/footer'

export default {
	name: "index",
	components: {
		LayoutHeader,
		LayoutFooter,
	}
}
</script>

<style scoped>
.app {
	min-width: 750px;
}
</style>
